import { useKeycloak } from "@react-keycloak/web";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import { translate } from "react-switch-lang";
import { Button, Row } from "reactstrap";
import { default as Swal, default as SweetAlert } from "sweetalert2";
import { TrainingPathDto } from "../../../models/trainingPathDto";
import { TrainingPathTanslationDto } from "../../../models/trainingPathTranslationDto";
import hasRoles from "../../../security/hasRoles";
import { useHttpClient } from "../../../security/hooks/axiosProvider";
import Breadcrumbs from "../../../shared/breadcrumb/breadCrumb";
import { RootState } from "../../../store";
import styles from "./editorOverview.module.scss";
import "./editorOverview.scss";

var HtmlToReactParser = require("html-to-react").Parser;

const EditorOverView: React.FC<{ t: (key: string) => string }> = props => {
  var htmlToReactParser = new HtmlToReactParser();
  const [element, setElement] = useState();
  const params = useParams<{ id: string }>();
  const history = useHistory();
  const keycloak = useKeycloak().keycloak;
  const httpClient = useHttpClient(keycloak.authenticated);
  const userCanSubscribe = !keycloak.authenticated;
  const userCanStart = hasRoles(["ROLE_ELEARNING_USER"], keycloak) && !hasRoles(["ROLE_ELEARNING_ADMIN"], keycloak);
  const [isUsers, setIsUsers] = useState(false);
  const [trainingTranslation, setTrainingTranslation] = useState<TrainingPathTanslationDto>(new TrainingPathTanslationDto());
  const onTrainingPathSubscribe = () => {
    history.push(`/signup?requested-training-path=${trainingTranslation.id}`);
  };

  const currentLang = useSelector((state: RootState) => state.language.currentLang);

  const addTrainingPathToUser = () => {
    httpClient.current?.post(`/trainingPath/addTrainingPathToUser/${trainingTranslation.id}`).then(() => {
      history.push(`/training-paths`);
    });
  };

  const startTrainingPath = async () => {
    httpClient.current?.get(`/trainingPath/isAlreadyStarted/${params.id}`).then(response => {
      if (!response.data) {
        httpClient.current?.post(`/trainingPath/startTrainingPath/${params.id}`);
      }
      history.push(`/training-paths/starting-modules/${params.id}`);
    });
  };

  useEffect(() => {
    async function getTemplate() {
      const existingTemplateResponse = await httpClient.current?.get<any>(`/trainingPath/${params.id}/template?currentLang=${currentLang.toUpperCase()}`);
      const traninginPathTranslation = await httpClient.current?.get<Array<TrainingPathTanslationDto>>(`/trainingPathTranslation/trainingPath/${params.id}`);
      var trainingPathTranslation = traninginPathTranslation.data.find(tpt => tpt.language.toUpperCase() === currentLang.toUpperCase());
      setTrainingTranslation(trainingPathTranslation)
      var template = existingTemplateResponse.data.replace('<div class="replaced_template"></div>', trainingPathTranslation.addedTemplateText);
      setElement(htmlToReactParser.parse(template.replaceAll('<h4','<p class="text-huge"')));
      httpClient.current?.get(`/trainingPath/byUser`, { params: { language: currentLang.toUpperCase(), archived: false } }).then(response => {
        setIsUsers((response.data.content as TrainingPathDto[]).some(trainingPath => Number.parseInt(params.id) === trainingPath.id));
      });
    }
    getTemplate();
    // eslint-disable-next-line
  }, [currentLang]);

  return (
    <>
      <Breadcrumbs parent={props.t("training_path_list")} title={props.t("training_path_details")} />
      <div className={`${styles["editor-wrapper"]}`}>
        {element}
        <Row>
          <div className={`container ${styles["editor-button-wrapper"]}`}>
            {userCanSubscribe && (
              <Button color="primary" className={styles["subscribe-button"]} outline={false} onClick={onTrainingPathSubscribe}>
                {props.t("training_path_subscribe")}{" "}
              </Button>
            )}

            {userCanStart && isUsers && (
              <Button color="primary" className={styles["subscribe-button"]} outline={false} onClick={startTrainingPath}>
                {props.t("training_path_start")}{" "}
              </Button>
            )}

            {userCanStart && !isUsers && (
              <Button
                color="primary"
                className={styles["subscribe-button"]}
                outline={false}
                onClick={() => {
                  SweetAlert.fire({
                    title: props.t("ADD_PATH_CONFIRM_TITLE"),
                    cancelButtonText: props.t("cancel"),
                    confirmButtonText: props.t("ConfirmButton"),
                    confirmButtonColor: "#FF0000",
                    reverseButtons: true,
                    showCancelButton: true,
                    icon: "warning",
                  }).then(result => {
                    if (result.isConfirmed) {
                      addTrainingPathToUser();
                      Swal.fire(props.t("training_path_added_success"), "", "success");
                    }
                  });
                }}
              >
                {props.t("training_path_subscribe")}
              </Button>
            )}
          </div>
        </Row>
      </div>
    </>
  );
};

export default translate(EditorOverView);
